import { useId, useState } from "react";
import { buscarCupomVenda } from "../utils/cupomVendaFirebase";
import { calcularCupomVenda } from "../utils/cupomVenda";
import "./cupomVenda.css";

export function CupomVenda({subtotal,cupom,onChange,disabled=false}) {
  const id=useId(), [codigo,setCodigo]=useState(""), [erro,setErro]=useState(""), [busy,setBusy]=useState(false);
  const aplicar=async()=>{
    if(busy || disabled) return;
    setBusy(true);setErro("");
    try { const dados=await buscarCupomVenda(codigo,subtotal); onChange(dados); }
    catch(error) { setErro(error?.code ? "Não foi possível conferir o cupom. Verifique a conexão e tente novamente." : error.message); }
    finally {setBusy(false);}
  };
  let desconto=0, invalido="";
  if(cupom) {try {desconto=calcularCupomVenda(cupom,subtotal).desconto;}catch(error){invalido=error.message;}}
  return <div className="sale-coupon">
    <label htmlFor={id}>Cupom de desconto</label>
    {cupom ? <div className="sale-coupon-applied"><span><strong>{cupom.codigo}</strong>{!invalido && <> · − {desconto.toLocaleString("pt-BR",{style:"currency",currency:"BRL"})}</>}</span><button type="button" disabled={disabled} onClick={()=>{onChange(null);setErro("");}}>Remover cupom</button></div> : <div className="sale-coupon-entry"><input id={id} placeholder="Código do cupom" autoCapitalize="characters" autoComplete="off" maxLength={40} disabled={busy || disabled} value={codigo} onChange={e=>{setCodigo(e.target.value.toUpperCase());setErro("");}} onKeyDown={e=>{if(e.key === "Enter"){e.preventDefault();aplicar();}}}/><button type="button" disabled={busy || disabled || !codigo.trim()} onClick={aplicar}>{busy ? "Conferindo…" : "Aplicar"}</button></div>}
    {(erro || invalido) && <p role="alert">{erro || invalido}</p>}
    <small>Use os cupons cadastrados em Configurações → Loja.</small>
  </div>;
}
